import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { FIBU_BWA_GRUPPEN, FibuKonto } from './fibu-konto';
import { FibuKontoDialogComponent } from './fibu-konto-dialog/fibu-konto-dialog.component';

@Component({
    selector: 'kiene-kontenrahmen',
    templateUrl: './kontenrahmen.component.html',
    styleUrls: ['./kontenrahmen.component.scss'],
})
export class KontenrahmenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Kontenrahmen';
        this.tableDescriptor.uniqueIdentifier = 'Kontenrahmen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fibu_konto/';
        this.tableDescriptor.route = '/finanzen/kontenrahmen/';
        this.tableDescriptor.nameOfIdField = 'fibu_konto_id';
        this.tableDescriptor.searchPlaceholder = 'Kontonummer oder Bezeichnung suchen';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openDialog.bind(this);
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openDialog.bind(this);
        this.tableDescriptor.permissionView = 17010;
        this.tableDescriptor.permissionCreate = 17011;
        this.tableDescriptor.initialSortColumn = 'konto_nr';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.columns = [
            new TableColumn('konto_nr', 'Konto-Nr.'),
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('bwa_gruppe', 'BWA-Gruppe'),
            new TableColumn('konto_typ_label', 'Typ'),
            new TableColumn('konto_art', 'Art'),
            new TableColumn('sachkonto', 'Sachkonto'),
            new TableColumn('kostenstelle_suffix', 'Suffix'),
            new KieneBooleanTableColumn('aktiv', 'Aktiv'),
            new TableColumn('kommentar', 'Kommentar'),
        ];

        this.tableDescriptor.options.push(
            new TableOption(this.openDialog.bind(this), 'Editieren', 'edit', 17011),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.confirmAndDelete.bind(this), 'Löschen', 'delete', 17012),
        );

        this.tableDescriptor.filterItems.push(
            new FilterItem('Aufwand', '1', FilterItemType.CHECKBOX, 'konto_typ', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Ertrag', '2', FilterItemType.CHECKBOX, 'konto_typ', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Bestand', '3', FilterItemType.CHECKBOX, 'konto_typ', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Kreditor', '5', FilterItemType.CHECKBOX, 'konto_typ', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Aktiv', '1', FilterItemType.CHECKBOX, 'aktiv', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Inaktiv', '0', FilterItemType.CHECKBOX, 'aktiv', false),
        );
        FIBU_BWA_GRUPPEN.forEach(g => {
            this.tableDescriptor.filterItems.push(
                new FilterItem(g.bezeichnung, String(g.bwa_gruppe_id), FilterItemType.CHECKBOX, 'bwa_gruppe_id', false),
            );
        });
        this.tableDescriptor.filterItems.push(
            new FilterItem('Ohne BWA-Gruppe', null, FilterItemType.CHECKBOX, 'bwa_gruppe_id', false),
        );
    }

    openDialog(konto?: FibuKonto) {
        const dialogRef = this.dialog.open(FibuKontoDialogComponent, {
            width: '560px',
            data: { konto: konto ? { ...konto } : null },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    confirmAndDelete(konto: FibuKonto) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: {
                title: 'Konto löschen',
                text: `Konto ${konto.konto_nr} „${konto.bezeichnung}“ wirklich löschen?`,
            },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (!ok) {
                return;
            }
            this.api.deleteEntity(this.apiBaseUrl + 'fibu_konto/delete.php', konto).subscribe({
                next: () => {
                    this.messageService.infoMessage('Konto gelöscht.');
                    this.api.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Konto konnte nicht gelöscht werden.', err);
                    this.api.reload();
                },
            });
        });
    }
}
